export const APPLICANT_VIEWING_CARD_PAGE = 1

export const APPLICANT_VIEWING_CARD_PAGE_SIZE = 5

export const QA_NAME_APPLICANT_VIEWING_CARD = 'applicantViewingCard'

export const QA_NAME_APPLICANT_VIEWING_CARD_BOOK = 'applicantViewingCardBook'

export const QA_NAME_APPLICANT_VIEWING_CARD_OPEN = 'applicantViewingCardOpen'

export const QA_NAME_APPLICANT_VIEWING_CARD_RETRY = 'applicantViewingCardRetry'
